/**
 * O rótulo da tecla modificadora, para tooltip: `⌘` no Mac, `Ctrl` no resto.
 *
 * Mesma leitura que `global/components/table/createContextMenu.js` já usa
 * (`navigator.userAgent`), e não `navigator.platform`, que é obsoleto.
 */
const SIMBOLO_COMANDO_MAC = '⌘'
const ROTULO_CONTROLE = 'Ctrl'

export function ehMac(agente) {
  const doBrowser = typeof navigator === 'undefined' ? '' : navigator.userAgent
  const ua = agente === undefined ? doBrowser : agente
  return String(ua || '').includes('Mac')
}

/** `Ctrl+Shift+O` no Windows/Linux, `⌘+Shift+O` no Mac. */
export function atalho(teclas, agente) {
  const modificador = ehMac(agente) ? SIMBOLO_COMANDO_MAC : ROTULO_CONTROLE
  return [modificador].concat(teclas).join('+')
}

/** `<rótulo> (<atalho>)` — o texto que vai no `title`/`aria-label`. */
export function rotuloComAtalho(rotulo, teclas, agente) {
  return rotulo + ' (' + atalho(teclas, agente) + ')'
}
